let $ = jQuery;

class Dropdown {

  constructor($dropdown) {
    this.$dropdown = $dropdown;
    this.$select = this.$dropdown.find("select");
    this.activeClass = "dropdown-active";

    this.origVal = this.$select.val();

    this.bind();
  }

  bind() {
    this.$select.change(() => this.toggleDropdown());
  }

  toggleDropdown() {

    if (this.$select.val() == this.origVal) {
      this.$dropdown.removeClass(this.activeClass);
    }
    else {
      this.$dropdown.addClass(this.activeClass);
    }
  }
}

module.exports = {

  attach: function(context, settings) {
    let $dropdowns = $(".dropdown");

    if ($dropdowns.length > 0) {
      $dropdowns.each((index, el) => {
        let dropdown = new Dropdown($(el));
      });
    }
  }
}
